import { Component, OnInit } from '@angular/core';
import {DataService} from '../../../../../../services/commande-client/data.service';

@Component({
  selector: 'app-tous-cmd-negoce',
  templateUrl: './tous-cmd-negoce.component.html',
  styleUrls: ['./tous-cmd-negoce.component.scss']
})
export class TousCmdNegoceComponent implements OnInit {

    constructor(private dataService: DataService) {}

    ngOnInit(): void {
        console.log('TousCmdNegoceComponent initialized');
        this.dataService.filterOrdersByStatus('Tous');
    }

}
